import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
import { SettingsService } from '../../core/services/settings.service';

@Component({
  selector: 'app-about',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {
  content = '';
  loading = true;
  error: string | null = null;

  constructor(
    private settingsService: SettingsService,
    private meta: Meta,
    private title: Title
  ) {}

  ngOnInit(): void {
    // Imposta i meta tag per la pagina About
    this.title.setTitle('About - AI PodLab');
    this.meta.updateTag({ name: 'description', content: 'Scopri di più su AI PodLab, il podcast dedicato alla scienza, tecnologia e intelligenza artificiale.' });
    this.meta.updateTag({ property: 'og:title', content: 'About - AI PodLab' });
    this.meta.updateTag({ property: 'og:description', content: 'Scopri di più su AI PodLab, il podcast dedicato alla scienza, tecnologia e intelligenza artificiale.' });
    
    this.loadAboutContent();
  }

  private loadAboutContent(): void {
    this.loading = true;
    this.error = null;

    this.settingsService.getByKey('about_content').subscribe({
      next: (response) => {
        if (response.success && response.data) {
          this.content = response.data.value;
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('Error loading about content:', err);
        this.error = 'Errore nel caricamento del contenuto';
        this.loading = false;
      }
    });
  }
}
